import React from 'react';
import { Image } from '@components/atoms/Image.tsx';
import { ImageDto } from '@src/types/types.ts';
import { StyledMarkdown } from '@components/atoms/StyledMarkdown.tsx';

interface ImageWithCaptionProps {
  image: ImageDto;
  alt?: string;
  caption?: string;
  className?: string;
}

export const ImageWithCaption: React.FC<ImageWithCaptionProps> = ({
  image,
  alt,
  caption,
  className = '',
}) => {
  return (
    <figure className={`w-full ${className}`}>
      <div className="rounded-bonusLarge overflow-hidden mb-4">
        <Image
          image={image}
          alt={alt || ''}
          className="w-full h-auto object-left max-h-[400px]"
          lazy={false}
        />
      </div>
      <StyledMarkdown markdown={caption} />
    </figure>
  );
};

export default ImageWithCaption;
